import React, { Component } from "react";
import { connect } from "react-redux";
import SubmissionRender from "containers/submission/SubmissionRender";
import { runEcoWizardBLC } from "actions/battery/blcRequest";
import { clearRequest } from "actions/request";
import { clearWizard } from "actions/wizard";

class EcoSubmitBLC extends Component {
  componentDidMount() {
    this.props.runEcoWizardBLC(this.props.user);
  }

  componentWillUnmount() {
    this.props.clearRequest();
    this.props.clearWizard();
  }

  render() {
    return <SubmissionRender history={this.props.history} />;
  }
}

export default connect(null, {
  runEcoWizardBLC,
  clearRequest,
  clearWizard
})(EcoSubmitBLC);
